var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade-top"}},[(_vm.showNotification)?_c('div',{staticClass:"notice-bar flex middle center",on:{"click":_vm.onClick}},[_vm._v("\n      "+_vm._s(_vm.notificationText)+"\n    ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }